// import ModalForm from "./Form";
import PlacementListForm from "./PlacementListForm";
import { PLACEMENT, DATATABLE_EXPORT } from "../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../Config/ApiUrl";

export const Schema = {
	components: { PlacementListForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: PLACEMENT,
			tableId: "placement-list-table",
			formId: "placement-list-form",
			rowData: {},
			tableColumns: [
				{
					title: "CLC ID No",
					type: "text",
					key: "clc_id_number",
				},
				{
					title: "Full Name",
					type: "custom-html",
					key: "lead",
					modifier: (lead) => {
						return lead?.full_name;
					}

				},
				{
					title: "Age",
					type: "custom-html",
					key: "lead",
					modifier: (lead) => {
						return lead?.age;
					}
				},
				{
					title: "Assigned By",
					type: "custom-html",
					key: "assigned_by",
					modifier: (value) => {
						return value?.full_name;
					},
				},
				{
					title: "Sub Status",
					type: "custom-html",
					key: "sub_status",
					modifier: (value) => {
						if (value && value.status) {
							return `<span class="badge badge-sm badge-pill badge-${value.color_status ?? 'primary'}">${this.$t(
								value.status
							)}</span>`;
						}
					},
				},
				{
					title: "Class Name",
					type: "custom-html",
					key: "assign_schedule_id",
					modifier: (value) => {
						return value?.schedule_recommendation?.course_id?.course_name;
					}
				},
				{
					title: "Prod Status",
					type: "custom-html",
					key: "sub_status",
					modifier: (value) => {
						if (value && value.status) {
							return `<span class="badge badge-sm badge-pill badge-${value.color_status ?? 'primary'}">${this.$t(
								value.status
							)}</span>`;
						}
					},
				},
				{
					title: "Course Consultant",
					type: "custom-html",
					key: "assign_schedule_id",
					modifier: (value) => {
						return value?.schedule_recommendation?.course_id?.course_sc_supervisor_id?.full_name;
					}
				},
				{
					title: "Student Care",
					type: "custom-html",
					key: "assign_schedule_id",
					modifier: (value) => {
						return value?.schedule_recommendation?.course_id?.course_sc_id?.full_name;
					}
				},
				{
					title: "Main Teacher",
					type: "text",
					key: "clc_id_number",
				},
				{
					title: "Group Class",
					type: "custom-html",
					key: "assign_schedule_id",
					modifier: (value) => {
						return value?.schedule_recommendation?.course_group_id?.course_group_name;
					}
				}
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "PlacementListTable",
				url: PLACEMENT,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "app-add-modal",
						// component: "placement-list-form",
						modalId: "placement-list-form",
					},
					{
						title: "Lead Profile",
						icon: "user", // You can use an appropriate icon here
						type: "decide-placement-page", // or "page" if you want to navigate to a new page
						url: "", // Specify the URL you want to navigate to
						target: "", // "_blank" if you want to open the URL in a new tab
						uniqueKey: (rowData) => rowData.lead.id,
					},
				],
				filters: [
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
	},
};
